

// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, addComingSoonUsers } from "../../Utils/Constants";
import { toast } from "react-toastify";

export const hitAddComingSoonUserApi = createAsyncThunk(
  "hitAddComingSoonUserApi",
  async (payload) => {
    try {
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          //Authorization: `${localStorage.getItem("professionalToken") ? localStorage.getItem("professionalToken") : localStorage.getItem("clientToken")}`,
        }
      };
      const url = ApiBaseUrl + addComingSoonUsers;
      const response = await axios.post(url,payload, config);
      return response.data;
    } catch (error) {
      toast.error(error.response.data.message);
      throw error.response.data;
    }
  }
);

const AddComingSoonUsersSlice = createSlice({
  name: "contactUsReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearAddComingSoonUsersSlicesData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitAddComingSoonUserApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitAddComingSoonUserApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitAddComingSoonUserApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearAddComingSoonUsersSlicesData } = AddComingSoonUsersSlice.actions;
export default AddComingSoonUsersSlice.reducer;